var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Help-Chat-2--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Help Chat 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-chat-2--bubble-help-mark-message-query-question-speech-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.99815 0.551881c-1.16638 0.000363 -2.31081 0.317086 -3.31141 0.916439 -1.0006 0.59935 -1.81989 1.45888 -2.37062 2.48704C0.765388 4.98352 0.503852 6.14181 0.559363 7.30686 0.614874 8.47191 0.985355 9.60009 1.63135 10.5712L0.550049 13.4481l3.620851 -0.6548c0.87189 0.4261 1.82871 0.6499 2.79912 0.6547 0.97041 0.0048 1.92939 -0.2095 2.80546 -0.6269 0.87602 -0.4174 1.64662 -1.0272 2.25422 -1.7838 0.6076 -0.7567 1.0366 -1.64076 1.255 -2.58629 0.2183 -0.94554 0.2205 -1.92817 0.0062 -2.87465 -0.2142 -0.94647 -0.6393 -1.83239 -1.2436 -2.5917 -0.6043 -0.75931 -1.3722 -1.37243 -2.24645 -1.79365C8.92661 0.769778 7.96857 0.551308 6.99815 0.551881v0Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.51013 5.51195c0 -0.2943 0.08727 -0.582 0.25078 -0.8267 0.1635 -0.24471 0.3959 -0.43543 0.6678 -0.54805 0.2719 -0.11263 0.57109 -0.1421 0.85974 -0.08468 0.28865 0.05741 0.55379 0.19913 0.7619 0.40724 0.2081 0.2081 0.34982 0.47324 0.40723 0.76189 0.05742 0.28865 0.02795 0.58784 -0.08467 0.85974 -0.11263 0.2719 -0.30335 0.5043 -0.54805 0.6678 -0.24471 0.16351 -0.5324 0.25078 -0.82671 0.25078v0.99202",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.00008 10.4721c-0.13697 0 -0.248 -0.1111 -0.248 -0.248 0 -0.137 0.11103 -0.24803 0.248 -0.24803",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.99992 10.4722c0.13697 0 0.248 -0.111 0.248 -0.248s-0.11103 -0.248 -0.248 -0.248",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.98b064b351acc5b7bcf5f7d4f6ebd5a4.svg";
export { ForwardRef as ReactComponent };